/**
 * Page d'attente de validation partenaire pour les parents
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClockIcon } from '@heroicons/react/24/outline';

const InscriptionEnAttenteValidation = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-white shadow rounded-lg overflow-hidden">
        {/* Header */}
        <div className="bg-yellow-50 border-b border-yellow-100 px-6 py-8">
          <div className="flex items-center justify-center mb-4">
            <div className="bg-yellow-100 rounded-full p-4">
              <ClockIcon className="h-12 w-12 text-yellow-600" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">
            Validation de l'inscription en cours
          </h1>
          <p className="text-gray-600 text-center">
            Inscription via partenaire social
          </p>
        </div>

        {/* Contenu principal */}
        <div className="px-6 py-8">
          <div className="space-y-6">
            {/* Message principal */}
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
              <p className="text-gray-700">
                Vous avez indiqué que cette inscription a été effectuée dans le cadre
                d'un partenariat social. Nos équipes administratives vérifient actuellement
                que celle-ci correspond bien aux places pré-réservées par nos partenaires.
              </p>
            </div>

            {/* Étapes */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Prochaines étapes</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="h-8 w-8 rounded-full bg-yellow-500 flex items-center justify-center text-white text-sm font-medium">
                      1
                    </div>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-gray-900">Vérification en cours</p>
                    <p className="text-sm text-gray-500 mt-1">
                      Nos équipes vérifient votre inscription auprès de notre partenaire social
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium">
                      2
                    </div>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-gray-900">Validation</p>
                    <p className="text-sm text-gray-500 mt-1">
                      Vous serez notifié une fois l'inscription validée
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium">
                      3
                    </div>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-gray-900">Accès au dossier</p>
                    <p className="text-sm text-gray-500 mt-1">
                      Vous pourrez compléter les informations et documents requis
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Boutons d'action */}
          <div className="mt-8 flex justify-center space-x-4">
            <button
              onClick={() => navigate('/dashboard')}
              className="px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-md transition-colors"
            >
              Retour au tableau de bord
            </button>
            <button
              onClick={() => navigate('/inscriptions')}
              className="px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 font-medium rounded-md border border-gray-300 transition-colors"
            >
              Voir mes inscriptions
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InscriptionEnAttenteValidation;
